import { getApiClient } from '../api-client'
import { User } from '../../type/User'

export type CreateUserRequest = {
  email: string
  password: string
  firstName: string
  lastName: string
}

const baseUrl = '/User'

const userApi = {
  async loadAllUsers() {
    const apiClient = getApiClient()
    const response = await apiClient.get<User[]>(baseUrl)
    return response.data
  },

  async createUser(user: CreateUserRequest) {
    const apiClient = getApiClient()
    const response = await apiClient.post<User>(baseUrl, user)
    return response.data
  },

  async login(email: string, password: string) {
    const apiClient = getApiClient()
    const response = await apiClient.post<User>(`${baseUrl}/Login`, {
      email,
      password,
    })

    return response.data
  },

    async updateAdultContentPreference(
    id: number,
    allowAdultContent: boolean
  ) {
    const apiClient = getApiClient()

    const response = await apiClient.put<User>(
      `${baseUrl}/${id}/AdultContent`,
      allowAdultContent
    )

    return response.data
  },



}

export default userApi
